import { render, staticRenderFns } from "./LocsHistorialTabContent.vue?vue&type=template&id=744c8c06&scoped=true"
import script from "./LocsHistorialTabContent.vue?vue&type=script&lang=js"
export * from "./LocsHistorialTabContent.vue?vue&type=script&lang=js"
import style0 from "./LocsHistorialTabContent.vue?vue&type=style&index=0&id=744c8c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c8c06",
  null
  
)

export default component.exports